var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "current"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12a3 3 0 1 1-5.943-.581c1.474.541 2.927-.882 2.405-2.371Q11.723 9.002 12 9a3 3 0 0 1 3 3m-2.985-7C4.446 5 0 11.551 0 11.551S4.835 19 12.015 19C19.748 19 24 11.551 24 11.551S19.709 5 12.015 5M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10"
  })));
};
export default SvgEye;